import React, { useMemo } from "react";
import { FormA } from "./components/FormA";
import { FormB } from "./components/FormB";

export enum ABCoin {
  A = "A",
  B = "B",
}

export const AboutUs = () => {
  const abCoin = useMemo(() => {
    if (typeof window === "undefined") return ABCoin.A;
    const coin = localStorage.getItem("ABCoin");

    if (!coin) {
      const auxAbCoin = Math.random() < 0.5 ? ABCoin.A : ABCoin.B;
      localStorage.setItem("ABCoin", auxAbCoin);
      window.location.reload();
      return auxAbCoin;
    }

    return coin as ABCoin;
  }, []);

  return (
    <>{abCoin === ABCoin.A ? <FormA /> : abCoin === ABCoin.B && <FormB />}</>
  );
};

export default AboutUs;
